import { DialogType } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { ModalInstance, ReactModalOptions,ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { LinkedTaskInfo } from '~src/ts/models/LinkedTaskInfo';

import { LinkedTaskDialogState } from '../state/LinkedTaskStateTypes';
import { convertToLinkedTaskDialogState } from '../utils/LinkedTaskHelpers';
import { LinkedTaskDialogStateContextProvider } from './LinkedTaskDialogStateContextProvider';
import { LinkedTasksDialogContent } from './LinkedTasksDialogContent';

const dialogBodyStyle: React.CSSProperties = {
  padding: 0,
};

export function editLinkedTaskDialog(linkedTaskInfo: LinkedTaskInfo): Promise<any> {
  let modalInstance: ModalInstance;
  const dismiss = () => modalInstance.dismiss();
  const props = {
    linkedTaskState: convertToLinkedTaskDialogState(linkedTaskInfo),
    dismiss: dismiss
  };
  const dialog: ReactModalOptions = {
    type: DialogType.NormalWithTitleBar,
    title: Messages.linkedTasksEditLinkedTasks(),
    dialogContent: <EditLinkedTaskDialog {...props}/>,
    showCloseButton: true,
    dialogWidth: 800,
    dialogHeight: 525,
    shouldRecenterOnUpdate: true,
    dialogBodyStyle: dialogBodyStyle,
  };
  modalInstance = ReactModalService.open(dialog);
  return modalInstance.result.catch(() => {});
}

export interface EditLinkedTaskDialogProps {
  linkedTaskState: LinkedTaskDialogState;
  dismiss: () => void;
}

export function EditLinkedTaskDialog(props: EditLinkedTaskDialogProps): JSX.Element {
  return (
    <LinkedTaskDialogStateContextProvider>
      <LinkedTasksDialogContent {...props}/>
    </LinkedTaskDialogStateContextProvider>
  );
}
